import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1b67b98"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h350" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftHeadImgBg leftHeadImgPurfuture" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://www.aowok.com/upload/img/assets/PurUser.jpg",
      class: "leftHeadImg bgW"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm0 userName" }, "Purfuture"),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm0 userMark" }, "www.Purfuture.com"),
  /*#__PURE__*/_createElementVNode("p", { class: "leftDis lh33" }, " 自2022年起，本站变更为个人类展示网站。将禁用（不限于评论，发文，留言等）与会员、用户类相关服务。如需解答、咨询、了解、合作及服务的，可在本站底部的邮件方式、右侧的关于我们进行直接咨询。如对本站有任何意见或建议，同样欢迎您向我反馈。我将为帮助我们成长的朋友最大的帮助。 ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h350" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftHeadImgBg leftHeadImgAuthor" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://www.aowok.com/upload/img/assets/images/m1.png",
      class: "leftHeadImg"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm0 userName" }, "钟锦华"),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm0 userMark" }, "Menton Chung"),
  /*#__PURE__*/_createElementVNode("p", { class: "leftDis lh25" }, [
    /*#__PURE__*/_createTextVNode(" 我是缘梦心理布道者。运维本真缘梦单靠个人力量属实不易，感激一路以来资助缘梦的朋友们。新站这4年来，朋友们对缘梦的信任，是我前进的最大动力。现在由于访客较多，在非紧急情况下，建议通过"),
    /*#__PURE__*/_createElementVNode("a", { href: "http://localhost:50332" }, "www.aowok.com"),
    /*#__PURE__*/_createTextVNode("进行学习，在aowok.com底部说出你的疑问或需求，我更希望获得你分享的建议或意见。并请留下你的联系方式（邮件或微信）以便以后我们能有更好的交流。谢谢 ")
  ])
], -1))
const _hoisted_3 = { class: "boxliteQr" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt35" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftArt" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "tcm1 userName" }, "微信公众号"),
    /*#__PURE__*/_createElementVNode("p", { class: "tcm1 userMark" }, "Wechat public account"),
    /*#__PURE__*/_createElementVNode("p", { class: "tcm1" }, "本真缘梦")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "rightImg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://www.aowok.com/upload/img/assets/images/gongzhong.jpg",
      style: {"width":"90px"}
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt35 df" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftImg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://www.aowok.com/upload/img/assets/images/wechat.jpg",
      style: {"width":"90px"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "rightArt" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "tcm2 quName" }, "Purfuture"),
    /*#__PURE__*/_createElementVNode("p", { class: "tcm2 quMark2" }, "微信问答"),
    /*#__PURE__*/_createElementVNode("p", { class: "tcm2" }, "|疑问|学习|求助|")
  ])
], -1))
const _hoisted_6 = { class: "mt35" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "leftArt",
  style: {"margin-top":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "tcm1 userName" }, "实时聊天空间"),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm1 userMark" }, "无需账户的答疑空间"),
  /*#__PURE__*/_createElementVNode("p", { class: "tcm1" }, "Question and answer")
], -1))
const _hoisted_8 = { class: "rightImg" }
const _hoisted_9 = { class: "h350" }
const _hoisted_10 = { class: "leftHeadImgBg leftHeadImgUser" }
const _hoisted_11 = {
  key: 0,
  src: "https://www.aowok.com/upload/img/assets/PurUser.jpg",
  class: "left-HeadPortrait",
  style: {"line-height":"48px"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 4,
  class: "talkbubble"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "◣online", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "tcm0 userName" }
const _hoisted_17 = { class: "tcm0 userMark" }
const _hoisted_18 = { class: "tcm0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, " 4.8", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "c8e8e8e" }, " (5Max)", -1))
const _hoisted_21 = { class: "tcm0" }
const _hoisted_22 = { class: "leftTa" }
const _hoisted_23 = { class: "leftTaTr" }
const _hoisted_24 = {
  colspan: "2",
  class: "leftTaA",
  width: "100%"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "leftTaAJin" }, "升级进度", -1))
const _hoisted_26 = { class: "leftTaTr" }
const _hoisted_27 = {
  width: "30%",
  class: "leftTaA"
}
const _hoisted_28 = {
  width: "70%",
  class: "leftTaB"
}
const _hoisted_29 = { class: "leftTaTr" }
const _hoisted_30 = { class: "leftTaA" }
const _hoisted_31 = { class: "leftTaB" }
const _hoisted_32 = { class: "leftTaTr" }
const _hoisted_33 = { class: "leftTaA" }
const _hoisted_34 = { class: "leftTaB" }
const _hoisted_35 = { class: "bg-purple" }
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = ["alt", "title"]
const _hoisted_38 = { class: "m0" }
const _hoisted_39 = {
  key: 0,
  class: "m0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_qrcode = _resolveComponent("a-qrcode")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_fund_filled = _resolveComponent("fund-filled")!
  const _component_book_filled = _resolveComponent("book-filled")!
  const _component_wallet_filled = _resolveComponent("wallet-filled")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_b_aowokOneDay = _resolveComponent("b-aowokOneDay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userInfo == null)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 0,
          class: "leftCard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
              class: "leftTabs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "Purfuture",
                  class: "cardTab"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: "Author",
                  class: "cardTab"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "3",
                  tab: "Contact",
                  class: "cardTab"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_qrcode, {
                            value: _ctx.userRead.url,
                            "error-level": "L",
                            size: 110,
                            bordered: false
                          }, null, 8, ["value"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_a_card, {
          key: 1,
          class: "leftCard"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  (_ctx.userInfo.HeadPortrait.length==0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: 'https://www.aowok.com/upload/img/User/HeadPortrait/' + _ctx.userInfo.HeadPortrait,
                        class: "leftHeadImg",
                        style: {"line-height":"48px"}
                      }, null, 8, _hoisted_12)),
                  (_ctx.userInfo != null)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        class: "leftLvImg",
                        style: _normalizeStyle('background-image:https://www.aowok.com/upload/img/assets/LVuser/' +
            _ctx.userInfo.UserClass +
              _ctx.Level(_ctx.userInfo.OldMarkFen) +
              '.jpg')
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (_ctx.userInfo != null)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 3,
                        class: "leftLvImg2",
                        style: _normalizeStyle({
            'background-image': `url(${'https://www.aowok.com/upload/img/assets//LVuser/' +
            _ctx.userInfo.UserClass +
              _ctx.Level(_ctx.userInfo.OldMarkFen) +
              '.jpg'})`,
          })
                      }, [
                        _createElementVNode("span", null, "Lv." + _toDisplayString(_ctx.Level(_ctx.userInfo.OldMarkFen)), 1)
                      ], 4))
                    : _createCommentVNode("", true),
                  (_ctx.userInfo != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.userInfo.UserName), 1),
              _createElementVNode("p", _hoisted_17, "缘梦" + _toDisplayString(_ctx.userdata.SerClassName), 1),
              _createElementVNode("p", _hoisted_18, [
                _createVNode(_component_a_rate, {
                  value: 4.8,
                  disabled: "",
                  style: {"font-size":"12px"}
                }, null, 8, ["value"]),
                _hoisted_19,
                _hoisted_20
              ]),
              _createElementVNode("p", _hoisted_21, [
                _createVNode(_component_a_button, {
                  style: {"margin-top":"6px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoPurhome()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("进入服务")
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkDataF5())),
                  class: "leftDelteleToken"
                }, "刷新")
              ]),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("tr", _hoisted_23, [
                  _createElementVNode("th", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_a_progress, {
                      class: "lh10",
                      "stroke-color": {
              '0%': '#b2dfff',
              '50%': '#6ab5ff',
              '100%': '#6ab5ff',
            },
                      percent: _ctx.LevelLine(_ctx.userInfo.OldMarkFen),
                      "show-info": true
                    }, null, 8, ["percent"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_26, [
                  _createElementVNode("th", _hoisted_27, [
                    _createVNode(_component_fund_filled, { class: "fontP8" }),
                    _createTextVNode("经验值 ")
                  ]),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.userInfo.OldMarkFen) + "点", 1)
                ]),
                _createElementVNode("tr", _hoisted_29, [
                  _createElementVNode("th", _hoisted_30, [
                    _createVNode(_component_book_filled, { class: "fontP8" }),
                    _createTextVNode("资历 ")
                  ]),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.UserComDateName (_ctx.userInfo.AddTime)+_ctx.LevelName(_ctx.userInfo.OldMarkFen)), 1)
                ]),
                _createElementVNode("tr", _hoisted_32, [
                  _createElementVNode("th", _hoisted_33, [
                    _createVNode(_component_wallet_filled, { class: "fontP8" }),
                    _createTextVNode("积分 ")
                  ]),
                  _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.userInfo.Fen) + "点", 1)
                ])
              ])
            ])
          ]),
          _: 1
        })),
    (_ctx.leftHomeSt.letterView)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 2,
          title: "自评量表",
          class: "box-card",
          style: {"margin-top":"24px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.letterList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 8,
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.gotoLetter('/Letter/'+item.url)),
                          title: item.name +'\n('+item.url.substring(item.url.length-2,item.url.length)+'题'+'-'+item.lei+item.xiang+'项)\n'+item.lClass+'(需时约'+item.time+'分钟)'
                        }, [
                          _createElementVNode("img", {
                            src: "https://www.aowok.com/upload/img/assets/images/Letter/TAS26.png",
                            style: {"width":"56px"},
                            alt: item.dp,
                            title: item.dp
                          }, null, 8, _hoisted_37),
                          _createElementVNode("span", null, _toDisplayString(item.name), 1)
                        ], 8, _hoisted_36)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.userInfo != null)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 3,
          title: _ctx.userInfo.SignInTime== _ctx.DateGang()?'今天任务':'每日成长',
          style: {"margin-top":"24px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              (_ctx.userInfo != null&&_ctx.userInfo.SignInTime!= _ctx.DateGang())
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                    _createVNode(_component_a_button, {
                      class: "onedayqian",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkOneDayQian())),
                      disabled: _ctx.leftHomeSt.lockQian,
                      style: _normalizeStyle({
          'background-image': `url(https://www.aowok.com/upload/img/assets/Collocation/MS/29.jpg)})`,
        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("签到领积分（解锁今天任务）")
                      ]),
                      _: 1
                    }, 8, ["disabled", "style"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aowokArticleList, (item, index) => {
                return (_openBlock(), _createBlock(_component_b_aowokOneDay, {
                  key: index<8,
                  id: item.id,
                  keyWord: item.keyWord,
                  keyWordId: item.keyWordId,
                  imagesId: item.imagesId,
                  addTime: item.addTime,
                  title: item.title,
                  descriptions: item.descriptions,
                  loginName: item.loginName,
                  HeadPortrait: item.HeadPortrait
                }, null, 8, ["id", "keyWord", "keyWordId", "imagesId", "addTime", "title", "descriptions", "loginName", "HeadPortrait"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}